import { render, staticRenderFns } from "./ColourWheel.vue?vue&type=template&id=4a4d263e&"
import script from "./ColourWheel.vue?vue&type=script&lang=js&"
export * from "./ColourWheel.vue?vue&type=script&lang=js&"
import style0 from "./ColourWheel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports